import { inject, Injectable } from '@angular/core';
import {
    DescriptionListDialogComponent,
    DescriptionListDialogData,
} from '../components/description-list-dialog/description-list-dialog.component';
import { SharedDialogService } from './shared-dialog.service';

/**
 * Entry point for opening a dialog that explains a set of terms with descriptions.
 *
 * Inject this service and call {@link open} with a title and {@link DescriptionListDialogData}.
 * Use it for inline help content (e.g. form field visibility options, case statuses).
 */
@Injectable({
    providedIn: 'root',
})
export class DescriptionListDialogService {
    private readonly sharedDialogService = inject(SharedDialogService);

    public open(data: DescriptionListDialogData): void {
        this.sharedDialogService.open(DescriptionListDialogComponent, {
            data,
        });
    }
}
